export default __webpack_public_path__ + "static/media/footer_pci.e3027344.svg";